import { lighten, Paper, styled } from '@mui/material';

export const RecommendationItemContentStyled = styled(Paper, { shouldForwardProp: (prop) => prop !== 'isAccepted' })<{
  isAccepted: boolean;
}>(({ theme, isAccepted }) => ({
  width: '100%',
  backgroundColor: isAccepted ? lighten(theme.palette.success.light, 0.9) : undefined,
}));
